// extracted by css-extract-rspack-plugin
export default {"section":"Y83yPpJ_EWkqYq6T","header":"FYM7HyhlwjYOrdYR","severityInfo":"KCF2l3VxUNY7oKK4","cve":"yupDxkv5wPwbmkVG","title":"Ep4AjOkwgzEOE644","emptySectionText":"hlxY5JtnPgEPThAt"};